<template>
<div class="page-wrapper">
    <div class="content container-fluid">

        <div class="row">
            <div class="col-md-12">
                <div class="page-head-box">
                    <h3>Attendance</h3>
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="admin-dashboard.html">Dashboard</a></li>
                            <li class="breadcrumb-item active" aria-current="page">Attendance</li>
                        </ol>
                    </nav>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12">
                <div class="row">
                    <div class="col-md-4">
                        <div class="form-group">
                            <label class="f-label">Select Employee</label>
                            <select @change="changeEmp" v-model="emp_mode" required class="select">
                                <option value="All">All Employee</option>
                                <option v-for="m in emp" :value="m">{{m.name}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label class="f-label">Select Month</label>
                            <select @change="changeDate(user)" v-model="m" required class="select">
                                <option v-for="m in months">{{m}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label class="f-label">Select Year</label>
                            <select @change="changeDate(user)" v-model="y" required class="select">
                                <option v-for="y in years">{{y}}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="allAttend">
                    <div class="calendar" v-if="emp_mode != 'All'">
                        <div class="weeks" v-for="week in weekdays">{{week}}</div>
                        <div v-if="!loading" v-for="i in days" class="calendar-day" v-bind:class="{'holiday':i.itm.holiday,'dump':i.itm.dump || i.itm.future}">
                            <div v-if="i.day != 'blank'" class="fw">
                                <span class="day">{{wdss(i.day)}} {{i.itm.public_holiday}}</span>
                                <div class="tags-calendar" v-if="!i.itm.dump">
                                    <div v-for="i in returnTime(i,user)">
                                        <span class="tags" v-if="!i.time_in && !i.leave && !i.future && !i.public_holiday && (!i.holiday || (i.holiday && i.in != '-'))" v-bind:class="{'err':i.in == '-'}"><span>IN</span> {{i.in}}</span>
                                        <span class="tags blue" v-if="i.time_in && !i.leave && !i.future && !i.public_holiday  && (!i.holiday || (i.holiday && i.in != '-'))" v-bind:class="{'err':i.time_in == '-'}"><span>IN</span> {{i.time_in}}</span>
                                        <span class="tags" v-if="!i.time_out  && !i.leave && !i.future && !i.public_holiday  && (!i.holiday || (i.holiday && i.out != '-'))" v-bind:class="{'err':i.out == '-'}"><span>OUT</span> {{i.out}}</span>
                                        <span class="tags blue" v-if="i.time_out  && !i.leave && !i.future && !i.public_holiday  && (!i.holiday || (i.holiday && i.out != '-'))" v-bind:class="{'err':i.time_out == '-'}"><span>OUT</span> {{i.time_out}}</span>
                                        <span class="leave" v-if="i.leave"> {{i.leave}}</span>
                                         <span class="leave" v-if="i.public_holiday"> Public Holiday</span>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="loading" class="loading">
                            <img src="@/assets/loading.gif">
                        </div>

                    </div>
                    <div  v-if="!loading && emp_mode != 'All'" class="deductionSummary">
                    
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="table-responsive att-table">
                                    <table class="table table-striped custom-table table-nowrap mb-0">
                                       
                                        <tbody>
                                            <tr>
                                                <td>
                                                    Deduction (In PKR)
                                                </td>
                                               
                                                <td>
                                                    PKR {{fine_amount[emp_mode.machine_id]}}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                     <table class="table table-striped custom-table table-nowrap mb-0">
                                        
                                        <tbody>
                                            <tr v-for="sum in summary">
                                                <td>
                                                    {{sum}}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <!-- <p class="soon">Coming Soon....</p> -->
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="c2" v-if="emp_mode == 'All'">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="table-responsive att-table">
                                    <table class="table table-striped custom-table table-nowrap mb-0">
                                        <thead>
                                            <tr>
                                                <th class="abc">Employee</th>
                                                <th v-for="i in days">{{wds(i.day)}}</th>
                                                <th>Fine Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="e in emp">
                                                <th class="abc">
                                                    <h2 class="table-avatar">
                                                        <a class="avatar" href="profile.html"><img alt="" src="@/assets/placeholder.png"></a>
                                                        <a href="profile.html">{{e.name}}</a>
                                                    </h2>
                                                </th>
                                                <td v-for="i in days" v-bind:class="{'holiday':i.itm.holiday}">
                                                    <div v-if="i.day != 'blank'" class="fw">
                                                        <div class="tags-calendar" v-if="i && !i.itm.dump">
                                                            <div v-for="i in returnTime(i,user)">
                                                                <span class="tags" v-if="!i.time_in && !i.leave && !i.future && !i.public_holiday && (!i.holiday || (i.holiday && i.in != '-'))" v-bind:class="{'err':i.in == '-'}"><span>IN</span> {{i.in}}</span>
                                                                <span class="tags blue" v-if="i.time_in && !i.leave && !i.future  && !i.public_holiday && (!i.holiday || (i.holiday && i.in != '-'))" v-bind:class="{'err':i.time_in == '-'}"><span>IN</span> {{i.time_in}}</span>
                                                                <span class="tags" v-if="!i.time_out  && !i.leave && !i.future  && !i.public_holiday && (!i.holiday || (i.holiday && i.out != '-'))" v-bind:class="{'err':i.out == '-'}"><span>OUT</span> {{i.out}}</span>
                                                                <span class="tags blue" v-if="i.time_out  && !i.leave && !i.future  && !i.public_holiday && (!i.holiday || (i.holiday && i.out != '-'))" v-bind:class="{'err':i.time_out == '-'}"><span>OUT</span> {{i.time_out}}</span>
                                                                <span class="alert" v-if="i.fine">PKR 500 Fine</span>
                                                                <span class="leave" v-if="i.leave"> {{i.leave}}</span>
                                                                <span class="leave" v-if="i.public_holiday"> Public Holiday</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>PKR {{fine_amount[e.machine_id]}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>

</div>
</template>

<script>
import axios from "axios"
import moment from "moment"
export default {
    data() {
        const month = new Date().getMonth();
        const year = new Date().getFullYear();
        return {
            days: [],
            weekdays: ["SUN", "MON", "TUES", "WED", "THR", "FRI", "SAT"],
            months: ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
            month: "",
            years: ["2022", "2023", "2024"],
            year: "",
            attendence: {},
            user: JSON.parse(localStorage.getItem('user')),
            currMonth: "",
            m: '',
            y: '',
            loading: true,
            emp: [],
            emp_mode: "",
            fine_amount: {},
            allSettings: [],
            holidays:{
                "08-07-2022":true,
                "09-07-2022":true,
                "10-07-2022":true,
                "11-07-2022":true,
                "12-07-2022":true,
                "13-07-2022":true,
                "08-08-2022":true,
                "09-08-2022":true

            },
            summary:[]
        }
    },

    created() {
        this.currMonth = moment().format("YYYY-MM");
        this.emp_mode = this.user
        this.processMonth(this.user)
        if (this.user.role == 'SuperAdmin' || this.user.role == 'HR') {
            this.getEmp('All')
        } else {
            this.getEmp(this.user)
        }
        //this.bulk()
        this.getAllSettings()
        document.getElementById("body").classList.remove("account-page");
    },
    methods: {
        getAllSettings() {
            axios.post(`${this.$store.state.api}hr_setting/_search`, {
                    from: 0,
                    size: 9000
                })
                .then((response) => {
                    ////console.log(response, 'Employees....');
                    var a = response.data.hits.hits;
                    var k = []
                    for (var ind in a) {
                        var c = a[ind]._source;
                        c.id = a[ind]._id
                        k.push(c)
                    }
                    this.allSettings = k;
                })
        },
        wds(i) {
            if (i < 10) {
                i = "0" + i;
            }
            return moment(this.y + '-' + this.m + '-' + i, 'YYYY-MMM-DD').format('ddd, Do MMM');
        },
        wdss(i) {
            if (i < 10) {
                i = "0" + i;
            }
            return moment(this.y + '-' + this.m + '-' + i, 'YYYY-MMM-DD').format('Do MMMM');
        },
        getEmp(ind) {
            if (ind == 'All') {
                var filters = [{
                    term: {
                        e: this.$store.state.event
                    }
                }]
            } else {
                var filters = [{
                        match: {
                            "line_manager.id": this.user.id
                        }
                    },
                    {
                        term: {
                            e: this.$store.state.event
                        }
                    }
                ]
            }

            axios.post(`${this.$store.state.api}hr_employee/_search`, {
                    from: 0,
                    size: 9000,
                    "sort": [{
                        "joining_date": "asc"
                    }],
                    query: {
                        bool: {
                            must: filters,
                        }
                    }
                })
                .then((response) => {
                    ////console.log(response, 'Employees....');
                    var a = response.data.hits.hits;
                    var d = []
                    for (var i in a) {
                        var c = a[i]._source;
                        c.id = a[i]._id;
                        d.push(c)
                    }
                    this.emp = d;
                    if (!this.emp.length || ind != 'All') {
                        this.emp.push(this.user)
                    }
                    // //console.log(this.emp, 'All Emp')
                })
        },
        changeEmp() {
            if (this.emp_mode == 'All') {
                for (var ind in this.emp) {
                    this.processMonth(this.emp[ind])
                }
            } else {
                this.user = this.emp_mode
                this.processMonth(this.user)
            }

        },
        bulk() {
            return;
            var d = [{
                    "id": "717"
                }, {
                    "id": "8"
                },
                {
                    "id": "9"
                },
                {
                    "id": "13"
                },
                {
                    "id": "2"
                },
                {
                    "id": "25"
                },
                {
                    "id": "62"
                },
                {
                    "id": "10"
                },
                {
                    "id": "11"
                },
                {
                    "id": "52"
                },
                {
                    "id": "64"
                },
                {
                    "id": "79"
                },
                {
                    "id": "69"
                },
                {
                    "id": "72"
                },
                {
                    "id": "47"
                },
                {
                    "id": "39"
                },
                {
                    "id": "71"
                },
                {
                    "id": "4"
                },
                {
                    "id": "19"
                },
                {
                    "id": "67"
                },
                {
                    "id": "73"
                },
                {
                    "id": "74"
                },
                {
                    "id": "45"
                },
                {
                    "id": "14"
                },
                {
                    "id": "54"
                },
                {
                    "id": "77"
                },
                {
                    "id": "75"
                },
                {
                    "id": "49"
                },
                {
                    "id": "80"
                },
                {
                    "id": "81"
                },
                {
                    "id": "78"
                },
                {
                    "id": "16"
                },
                {
                    "id": "48"
                }
            ]
            var dates = ["02", "03", "04", "05", "06", "09", "10", "11", "12", "13"]
            for (var ds in dates) {
                for (var ind in d) {
                    var data = {
                        "userID": d[ind].id,
                        "time": "20:00:00",
                        "dated": `${dates[ds]}-05-2022`,
                        "datetime": `2022-05-${dates[ds]}T20:00:00Z`,
                        "type": "OUT",
                        "indexed": 2
                    }
                    axios.post(`${this.$store.state.api}hr_markers/_doc`, data)
                }
            }

        },
        returnTime(d, u) {
            ////console.log(d,u)
            var attend = {}
            var dts = d.day;
            if (dts < 10) {
                dts = `0${dts}`;
            }
            ////console.log(this.attendence,u.machine_id,dts)
            if (this.attendence[u.machine_id] && this.attendence[u.machine_id][dts]) {
                var a = this.attendence[u.machine_id][dts]
                //console.log(a, 'this is a')
                if (a.leave) {
                    attend.leave = a.leave
                }
                if (a.time_in) {
                    attend.time_in = a.time_in
                }
                if (a.time_out) {
                    attend.time_out = a.time_out
                }
                attend.in = a.in;
                attend.out = a.out;

            } else {
                if (d.itm.holiday)
                    attend.holiday = true
                if (d.itm.future)
                    attend.future = true
                if (d.itm.public_holiday)
                    attend.public_holiday = true
            }
            if (!attend.in) {
                if (parseInt(dts) <= 17 && this.m == 'MAY' && this.y == 2022 && !d.itm.holiday && !d.itm.future) {
                    attend.in = '09:00:00'
                } else {
                    attend.in = '-'
                }

            }
            if (!attend.out) {
                if (parseInt(dts) <= 17 && this.m == 'MAY' && this.y == 2022 && !d.itm.holiday && !d.itm.future) {
                    attend.out = '19:00:00'
                } else {
                    attend.out = '-'
                }
            }
            return [attend];
        },
        changeDate(user) {
            this.currMonth = moment(this.m + '-' + this.y, 'MMMYYYY').format("YYYY-MM")
            if (this.emp_mode == 'All') {
                for (var ind in this.emp) {
                    this.processMonth(this.emp[ind])
                }
            } else {
                this.processMonth(user)
            }
        },
        processMonth(user) {
            this.loading = true;
            this.month = (this.months[parseInt(moment(this.currMonth, "YYYY-MM").format('MM')) - 1])
            //console.log(this.month,'Month Name')
            this.m = this.month;
            this.year = moment(this.currMonth, "YYYY-MM").format('YYYY')
            this.y = this.year;
            var wd = moment(this.currMonth, "YYYY-MM").startOf('month').format('d')
            ////console.log(wd)
            this.days = []
            this.attendence = {}
            for (var i = 0; i < wd; i++) {
                this.days.push({
                    day: 'blank',
                    itm: {
                        in: '-',
                        out: '-'
                    }
                });
            }
            for (var i = 1; i <= 31; i++) {
                if (moment(this.m + '-' + this.y + '-' + i, "MMM-YYYY-D").format() != 'Invalid date') {
                    if (moment(this.m + '-' + this.y + '-' + i, "MMM-YYYY-D").isBefore(moment("MAY-2022-01", "MMM-YYYY-D"))) {
                        ////console.log('Before');
                        this.days.push({
                            day: i,
                            itm: {
                                dump: true
                            }
                        });
                    } else if (moment(this.m + '-' + this.y + '-' + i, "MMM-YYYY-D").isAfter(moment())) {
                        this.days.push({
                            day: i,
                            itm: {
                                future: true,
                                in: '-',
                                out: '-'
                            }
                        });
                    } else if (moment(this.m + '-' + this.y + '-' + i, "MMM-YYYY-D").format("d") == 0 || moment(this.m + '-' + this.y + '-' + i, "MMM-YYYY-D").format("d") == 6) {
                        this.days.push({
                            day: i,
                            itm: {
                                holiday: true,
                                in: '-',
                                out: '-'
                            }
                        });
                    }else if(this.holidays[moment(this.m + '-' + this.y + '-' + i, "MMM-YYYY-D").format("DD-MM-YYYY")]){
                        console.log('Public Holidays',i)
                        this.days.push({
                            day: i,
                            itm: {
                                public_holiday: true,
                                in: '-',
                                out: '-'
                            },
                            public:true
                        });
                    } else {
                        ////console.log();
                        this.days.push({
                            day: i,
                            itm: {
                                in: '-',
                                out: '-'
                            }
                        });
                    }
                    console.log(this.days,'Days list')
                }

            }
            this.getLeaves(user)
        },
        getAttendance(user) {
            var y = this.y;
            var m = false;
            var nm = false
            for (var ins in this.months) {
                if (this.months[ins] == this.m) {
                    m = parseInt(ins) + 1
                }
            }
            nm = m + 1;
            if (m < 10) {
                m = "0" + m;
            }
            if (nm < 10) {
                nm = "0" + nm;
            }
            var filters = [{
                    term: {
                        userID: user.machine_id
                    }
                },
                {
                    "range": {
                        "datetime": {
                            "gte": `${y}-${m}-01`,
                            "lt": `${y}-${nm}-01`,
                        }
                    }
                }
            ]
            axios.post(`${this.$store.state.api}hr_markers/_search`, {
                    from: 0,
                    size: 9000,
                    "sort": [{
                        "indexed": "asc"
                    }],
                    query: {
                        bool: {
                            must: filters,
                        }
                    }
                })
                .then((response) => {
                    var p = response.data.hits.hits;
                    var g = []
                    for (var i in p) {
                        var s = p[i]._source
                        s.id = p[i]._id
                        g.push(s)
                    }
                    if (!this.attendence[user.machine_id]) {
                        this.attendence[user.machine_id] = {}
                    }
                    for (var i in g) {
                        var d = (moment(g[i].datetime).subtract("5", "hours").format('DD'));
                        ////console.log(d, g[i].datetime)

                        if (!this.attendence[user.machine_id][d]) {
                            this.attendence[user.machine_id][d] = {
                                in: '-',
                                out: "-"
                            }
                        }
                        if (!this.attendence[user.machine_id][d].in) {
                            this.attendence[user.machine_id][d].in = '-'
                        }
                        if (!this.attendence[user.machine_id][d].out) {
                            this.attendence[user.machine_id][d].out = '-'
                        }
                        if (this.attendence[user.machine_id][d].in == '-' && g[i].type == 'IN') {
                            this.attendence[user.machine_id][d].in = g[i].time
                        } else if (g[i].type == 'OUT') {
                            this.attendence[user.machine_id][d].out = g[i].time
                        }
                    }
                    ////console.log(this.attendence, 'Attendance')
                    this.sortData(user)
                })
                .catch((error) => {
                    ////console.log(error);
                })

        },
        getLeaves(user) {
            var y = parseInt(this.y)
            var m = false;
            var nm = false
            for (var ins in this.months) {
                if (this.months[ins] == this.m) {
                    m = parseInt(ins) + 1
                }
            }
            nm = m + 1;
            if (m < 10) {
                m = "0" + m;
            }
            if (nm < 10) {
                nm = "0" + nm;
            }
            //return;
            var filters = [{
                    term: {
                        employee_id: user.machine_id
                    }
                }, {
                    match: {
                        "status.line_manager": "Approved"
                    }
                },
                {
                    match: {
                        "status.hr": "Approved"
                    }
                },
                {
                    "range": {
                        "from_date": {
                            "gte": `${y}-${m}`,
                            "lt": `${y}-${nm}`,
                        }
                    }
                }
            ]
            axios
                .post(
                    this.$store.state.api + "hr_leave/_search", {
                        from: 0,
                        size: 9000,
                        query: {
                            bool: {
                                must: filters
                            }
                        }
                    }
                ).then(response => {
                    if (response.data.hits.hits.length) {
                        var s = response.data.hits.hits;
                        var t = []
                        for (var i in s) {
                            var f = s[i]._source;
                            f.id = s[i]._id;
                            t.push(f)
                        }
                        for (var i in t) {
                            var fm = t[i].from_date.split('-');
                            var fmd = fm[2]
                            if (!this.attendence[user.machine_id]) {
                                this.attendence[user.machine_id] = {}
                            }
                            if (!this.attendence[user.machine_id][fmd]) {
                                this.attendence[user.machine_id][fmd] = {}
                            }
                            this.attendence[user.machine_id][fmd].leave = t[i].type;
                            //////console.log(parseInt(t[i].no_of_days))
                            if (parseInt(t[i].no_of_days) > 1) {
                                var td = t[i].to_date.split('-');
                                var tdd = td[2]
                                var is = fmd;
                                var js = tdd;
                                var ks = parseInt(is)
                                var ls = parseInt(js)
                                ////console.log(ks, ls)
                                do {
                                    var c = ks;
                                    if (c < 10) {
                                        c = "0" + c;
                                    }
                                    if (!this.attendence[user.machine_id][c]) {
                                        this.attendence[user.machine_id][c] = {}
                                    }
                                    this.attendence[user.machine_id][c].leave = t[i].type;
                                    ks++;

                                } while (ks <= ls);
                            }
                        }
                    }
                    this.getApplications(user)
                })
        },
        getApplications(user) {
            var y = parseInt(this.y)
            var m = false;
            var nm = false
            for (var ins in this.months) {
                if (this.months[ins] == this.m) {
                    m = parseInt(ins) + 1
                }
            }
            nm = m + 1;
            if (m < 10) {
                m = "0" + m;
            }
            if (nm < 10) {
                nm = "0" + nm;
            }
            //return;
            var filters = [{
                    term: {
                        employee_id: user.machine_id
                    }
                }, {
                    match: {
                        "status.line_manager": "Approved"
                    }
                },
                {
                    match: {
                        "status.hr": "Approved"
                    }
                },
                {
                    "range": {
                        "dated": {
                            "gte": `${y}-${m}`,
                            "lt": `${y}-${nm}`,
                        }
                    }
                }
            ]
            axios
                .post(
                    this.$store.state.api + "hr_application/_search", {
                        from: 0,
                        size: 9000,
                        query: {
                            bool: {
                                must: filters
                            }
                        }
                    }
                ).then(response => {
                    if (response.data.hits.hits.length) {
                        var s = response.data.hits.hits;
                        var t = []
                        for (var i in s) {
                            var f = s[i]._source;
                            f.id = s[i]._id;
                            t.push(f)
                        }
                        for (var i in t) {
                            var fm = t[i].dated.split('-');
                            var fmd = fm[2]
                            if (!this.attendence[user.machine_id]) {
                                this.attendence[user.machine_id] = {}
                            }
                            if (!this.attendence[user.machine_id][fmd]) {
                                this.attendence[user.machine_id][fmd] = {}
                            }
                            if (t[i].type == "Forgot to Mark") {
                                var tp = "FTM:"
                            } else if (t[i].type == "Special Circumstance") {
                                var tp = "SC:"
                            } else {
                                var tp = "MT:"
                            }
                            if (t[i].time_type == 'Time In') {
                                this.attendence[user.machine_id][fmd].time_in = tp + t[i].time;
                            } else {
                                this.attendence[user.machine_id][fmd].time_out = tp + t[i].time;
                            }
                        }
                    }
                    this.getAttendance(user)
                })
        },
        sortData(user) {
            //console.log(this.attendence, 'All attendances',this.days)
            for (var ind in this.days) {
                if (this.days[ind].day < 10) {
                    var ds = `0${this.days[ind].day}`
                } else {
                    var ds = this.days[ind].day
                }
                // if (this.attendence[ds]) {
                //     this.days[ind].itm = this.attendence[ds]
                // }
            }
            var d = this.days
            this.days = []
            this.days = d;
            this.loading = false;
            ////console.log(this.attendence,'Attendance')
            this.calculate_fine(user)
        },
        login() {
            this.$router.push({
                path: "/dashboard"
            });
        },
        update(e) {
            ////console.log(e)
        },
        async calculate_fine(user) {
            if (!user.salary) {
                user.salary = "1000";
            }
            var set = false
            for (var ind in this.allSettings) {
                if (user.setting.id == this.allSettings[ind].id) {
                    set = this.allSettings[ind]
                }
            }
            var fine = 0;
            this.summary = []
            for (var ind in this.days) {
                var dt = parseInt(this.days[ind].day);
                    if (dt < 10) {
                        dt = "0" + dt
                    }
                var cDay = moment(this.y + '-' + this.m + '-' + dt, 'YYYY-MMM-DD');
                var tDay = moment(moment().format('YYYY-MMM-DD'),"YYYY-MMM-DD")
                //console.log(cDay.format('DD-MM-YYYY'),'C Days')
                if (this.days[ind].day != 'blank' && !this.days[ind].itm.future && !this.days[ind].itm.holiday && moment(cDay).isBefore(tDay)) {
                    
                    //console.log(this.attendence[user.machine_id][dt].leave,'THIS IS LEAVE')
                    if (this.attendence[user.machine_id][dt] && !this.attendence[user.machine_id][dt].leave) {
                        if (!this.attendence[user.machine_id][dt].time_in) {
                            if (this.attendence[user.machine_id][dt].in == '-' && set.is_max_chkin_fine) {
                                var d = parseFloat((parseFloat(set.max_chkin_fine) / 100) * (parseFloat(user.salary.replaceAll(',', '')) / 24));
                                fine = fine + d
                                console.log(dt,set.max_chkin_fine,d)
                                this.summary.push(`Dated: ${dt}, Fine Amount PKR ${parseInt(d)}, Time In Fine`)
                            } else {
                                var chkin = moment(moment().format('DD MM YYYY') + this.attendence[user.machine_id][dt].in, 'DD MM YYYY HH:mm:ss')
                                var setin_min = moment(moment().format('DD MM YYYY') + set.min_chkin_time, 'DD MM YYYY HH:mm:ss')
                                var setin_max = moment(moment().format('DD MM YYYY') + set.max_chkin_time, 'DD MM YYYY HH:mm:ss')
                                if (moment(chkin).isAfter(setin_min) && moment(chkin).isBefore(setin_max)) {
                                    // console.log('1st',chkin,setin_min,setin_max,dt,this.attendence[user.machine_id][dt].in,set.min_chkin_time,set.max_chkin_time)
                                    var d = parseFloat((parseFloat(set.min_chkin_fine) / 100) * (parseFloat(user.salary.replaceAll(',', '')) / 24));
                                    fine = fine + d
                                     console.log(dt,set.min_chkin_fine,d)
                                      this.summary.push(`Dated: ${dt}, Fine Amount PKR ${parseInt(d)}, Time In Fine`)
                                } else if (moment(chkin).isAfter(setin_max)) {
                                    //console.log('2nd',chkin,setin_min,setin_max,dt)
                                    var d = parseFloat((parseFloat(set.max_chkin_fine) / 100) * (parseFloat(user.salary.replaceAll(',', '')) / 24));
                                    fine = fine + d
                                     console.log(dt,set.max_chkin_fine,d)
                                      this.summary.push(`Dated: ${dt}, Fine Amount PKR ${parseInt(d)}, Time In Fine`)
                                }
                            }
                        }
                        if (!this.attendence[user.machine_id][dt].time_out) {
                            if (this.attendence[user.machine_id][dt].out == '-' && set.is_max_chkout_fine) {
                                var d = parseFloat((parseFloat(set.max_chkout_fine) / 100) * (parseFloat(user.salary.replaceAll(',', '')) / 24));
                                fine = fine + d
                                 console.log(dt,set.max_chkout_fine,d)
                                  this.summary.push(`Dated: ${dt}, Fine Amount PKR ${parseInt(d)}, Time Out Fine`)
                            } else {
                                var chkout = moment(moment().format('DD MM YYYY') + this.attendence[user.machine_id][dt].out, 'DD MM YYYY HH:mm:ss')
                                var setout_min = moment(moment().format('DD MM YYYY') + set.min_chkout_time, 'DD MM YYYY HH:mm:ss')
                                var setout_max = moment(moment().format('DD MM YYYY') + set.max_chkout_time, 'DD MM YYYY HH:mm:ss')
                                if (moment(chkout).isBefore(setout_min)) {
                                    // console.log('1st',chkin,setin_min,setin_max,dt,this.attendence[user.machine_id][dt].in,set.min_chkin_time,set.max_chkin_time)
                                    var d = parseFloat((parseFloat(set.min_chkout_fine) / 100) * (parseFloat(user.salary.replaceAll(',', '')) / 24));
                                    fine = fine + d
                                    console.log(dt,set.min_chkout_fine,d)
                                     this.summary.push(`Dated: ${dt}, Fine Amount PKR ${parseInt(d)}, Time Out Fine`)
                                } else if (moment(chkout).isBefore(setout_max)) {
                                    //console.log('2nd',chkin,setin_min,setin_max,dt)
                                    var d = parseFloat((parseFloat(set.max_chkout_fine) / 100) * (parseFloat(user.salary.replaceAll(',', '')) / 24));
                                    fine = fine + d
                                    console.log(dt,set.max_chkout_fine,d)
                                     this.summary.push(`Dated: ${dt}, Fine Amount PKR ${parseInt(d)}, Time Out Fine`)
                                }
                            }
                        }
                    } else if (this.attendence[user.machine_id][dt] && this.attendence[user.machine_id][dt].leave) {
                        console.log(this.attendence[user.machine_id][dt].leave)
                    }else if(this.holidays[cDay.format('DD-MM-YYYY')]){
                         console.log('Holidays');
                    }else {
                        var d = parseFloat((parseFloat(user.salary.replaceAll(',', '')) / 24));
                        //console.log(d);
                        fine = fine + d
                        console.log(dt,'Full Day',d)
                         this.summary.push(`Dated: ${dt}, Fine Amount PKR ${parseInt(d)}, Full Day Fine`)
                    }
                }

                // if(!this.days[ind].itm.future && !this.days[ind].itm.holiday && this.days[ind].day != 'blank'){
                //     if(this.days[ind].itm.in == '-' && set.is_max_chkin_fine){
                //         var d = parseFloat((parseFloat(set.max_chkin_fine) / 100) * (parseFloat(this.user.salary.replaceAll(',','')) / 30));
                //         //console.log(d);
                //         fine = fine + d
                //     }
                //     if(this.days[ind].itm.out == '-' && set.is_max_chkout_fine){
                //         var d = parseFloat((parseFloat(set.max_chkout_fine) / 100) * (parseFloat(this.user.salary.replaceAll(',','')) / 30));
                //         //console.log(d);
                //         fine = fine + d
                //     }
                // }
            }
            fine = Math.round(fine)
            console.log(fine)
            this.fine_amount[user.machine_id] = fine;

        }
    }
}
</script>

<style lang="postcss" scoped>
.table.custom-table>tbody>tr>td,
.table.custom-table>tbody>tr>th,
.table.custom-table>tfoot>tr>td,
.table.custom-table>tfoot>tr>th,
.table.custom-table>thead>tr>td,
.table.custom-table>thead>tr>th {
    padding: 10px 8px;
    vertical-align: middle;
    border-color: #dee2e6;
    min-width: 150px;
    text-align: center;
    border: 1px solid #ddd;
    max-width: 150px;
}

.abc {
    max-width: 500px !important;
    min-width: 230px !important;
    text-align: left !important;
}

.holiday {
    background: #fffce4;
}

.dump {
    background: #e9e9e9;
    border: 1px solid #c9c9c9 !important;
}

.fw {
    width: 100%
}

.deductionSummary {
    min-width: 100%;
}

.calendar {
    display: flex;
    width: 100%;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
}

.holiday {
    background: #fffce4 !important;
}

.calendar .calendar-day {
    display: flex;
    min-width: 14%;
    max-width: 14%;
    border: 1px solid #ddd;
    padding: 9px;
    height: 150px;
}

.blue {
    background: #2196f3 !important;
}

.calendar .weeks {
    min-width: 14%;
    display: flex;
    background: #1b1b1b;
    padding: 12px;
    justify-content: center;
    align-items: center;
    border: 1px solid #eee;
    font-weight: bold;
    color: #fff;
}

.soon {
    width: 100%;
    text-align: center;
    font-style: bold;
    margin-top: 20px;
}

thead th {
    position: -webkit-sticky;
    /* for Safari */
    position: sticky;
    top: 0;
    z-index: 2;
}

thead th:first-child {
    left: 0;
    z-index: 3;
}

tbody th {
    position: -webkit-sticky;
    /* for Safari */
    position: sticky;
    left: 0;
    z-index: 1;
}

.day {
    font-size: 12px;
    font-weight: bold;
    ;
}

tbody th h2 {
    font-size: 16px;
}

.att-table {
    max-height: 75vh;
    overflow: auto;
}

@media screen and (max-width: 800px) {

    .abc {
        max-width: 200px !important;
        min-width: 200px !important;
    }
}
</style>
